import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Container, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import ForwardArrow from "../../Assets/forward-arrow.svg";
import tick from "../../Assets/tick.png";
import Close from "../../Assets/close.svg";
import Exclamation from '../../Assets/exclamationcircle.svg';
import { GetQueryParam, migrateToBUBasedDC } from "../../util/helpers/funcHelper";


const ResetSuccess = () => {
  /** fetch tags and accordingly migrate to enterprise or consumer */
  const message = GetQueryParam('message');
  const success = GetQueryParam('success');
  const [linkExpired, setLinkExpired] = useState(false);

  useEffect(() => {
    if (message == "Access expired." || success==="false")
      setLinkExpired(true);
  }, [message, success])

  return (
    <React.Fragment>
      <Navbar showSignup={true} />
      <Container fluid className="main-container">
        <Modal show={true} centered contentClassName="mail-modal p-2">
          <Link to="/" style={{ marginLeft: "95%" }}>
            <img src={Close} height="14" width="14" alt="cross" />
          </Link>
          <Modal.Body>
            <Container className="text-center col-xs-1">
              {linkExpired ?
                <div>
                  <img
                    alt="mail-expiry"
                    src={Exclamation}
                    height="25"
                  />
                  <h4 className="mt-2">Reset password link has expired</h4>
                  <p className="mt-4 font-size-14">Visit below to generate new link</p>
                  <Link to="/forgot-password">
                    <p className="link justify-content-center d-flex">
                      Reset Password
                      <Link to="/forgot-password">
                        <img
                          alt=""
                          className="m-1"
                          src={ForwardArrow}
                          height="12"
                          width="13"
                          marginTop="-2px"
                        />
                      </Link>
                    </p>
                  </Link>
                </div>
                :
                <div>
                  <img alt="" src={tick} height="25" />
                  <h4 className="mt-2">Password reset Succesfully</h4>
                  <p className="mt-4 font-size-14">
                    You can now use your new password to sign in to your account.
                  </p>
                  <Link to="/login">
                    <p className="link justify-content-center d-flex">
                      Sign In
                      <Link to="/login">
                        <img
                          alt=""
                          className="m-1"
                          src={ForwardArrow}
                          height="12"
                          width="13"
                          marginTop="-2px"
                        />
                      </Link>
                    </p>
                  </Link>
                </div>
              }
            </Container>
          </Modal.Body>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default ResetSuccess;
